"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var RECORD_QUERY = "\n  mutation Record($record: RecordInput!) {\n      record(record: $record) \n  }\n";
exports.default = RECORD_QUERY;
//# sourceMappingURL=record.js.map